module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/f8e36975ba8a88b16cda4b8eb1ec9c02.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold0.svg
// module id = u0LN
// module chunks = 1